export default "__VITE_ASSET__C0c15HxM__"